
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"fill":"#fff","d":"M11.998 22.435a.5.5 0 01-.359-.152l-9.8-10.091A6.139 6.139 0 01.665 5.01a6.345 6.345 0 0110.084-1.617l1.249 1.139 1.263-1.152a6.281 6.281 0 014.43-1.806c1.716 0 3.322.672 4.522 1.891a6.149 6.149 0 01-.065 8.735l-9.791 10.083a.507.507 0 01-.359.152zM6.31 2.571a5.326 5.326 0 00-4.755 2.893 5.145 5.145 0 00.993 6.021l9.45 9.731 9.441-9.723a5.156 5.156 0 001-6.033 5.339 5.339 0 00-.939-1.294 5.298 5.298 0 00-3.807-1.592 5.307 5.307 0 00-3.745 1.531l-1.614 1.472a.5.5 0 01-.674 0l-1.6-1.459a5.355 5.355 0 00-3.75-1.547z"}})])])
          )
        }
      }
    